import Vue from 'vue'
import axios from 'axios'
import { notification } from 'ant-design-vue';
import router from '@/router';
import store from '@/store';
import i18n from '@/core/vue-i18n';

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL

/* Plafond volontairement large. Il valait 6 s, ce qui suffisait à toutes les pages sauf
 * une : filtrée par organisation, la liste des notifications répondait en 3 à 6 s, et
 * 75 requêtes sur 84 étaient abandonnées côté navigateur en 48 h de production. Comme la
 * page courante d'un tableau est pilotée par le `meta` de la réponse, une requête
 * abandonnée gelait la pagination — sans message, puisque rien ne remontait l'échec.
 *
 * Ce plafond n'est pas là pour rattraper un endpoint lent, c'est le rôle du back : il est
 * là pour qu'un serveur muet finisse par rendre la main. */
const TIMEOUT_MS = 30000;

const axiosAgent = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: TIMEOUT_MS
})

const err = (error) => {
  if (error.response) {
    // const token = Vue.ls.get('Authorization')
    if (error.response.status === 401) {
      store.dispatch('Logout');
    }
    if (error.response.status === 404) {
      if (error.response.config.headers['Authorization']) {
        router.push({name: '404'});
      }
    }
  } else if (!axios.isCancel(error)) {
    /* Ni réponse, ni annulation volontaire : timeout ou réseau coupé. Sans ce message,
     * l'écran reste tel quel et l'utilisateur croit que son clic n'a pas été pris. */
    notification.error({
      message: i18n.t('error.request_failed_title'),
      description: error.code === 'ECONNABORTED'
        ? i18n.t('error.request_timeout', { seconds: Math.round(TIMEOUT_MS / 1000) })
        : i18n.t('error.request_network'),
    });
  }

  return Promise.reject(error)
}

// request interceptor
axiosAgent.interceptors.request.use(config => {
  const token = Vue.ls.get('Authorization');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  config.headers['X-Language'] = `${localStorage.language ? localStorage.language : 'en'}`;

  // Inject current organization context
  const orgId = store.getters.getCurrentOrganizationId;
  if (orgId) {
    config.headers['X-Organization-Id'] = orgId;
  }

  return config;
}, err)

// response interceptor
axiosAgent.interceptors.response.use((response) => {
  return response.data
}, err)


export {
  axiosAgent as axios
}
